/**
 * CTA dinâmico por intensidade (low/medium/high) com WhatsApp deep-link.
 */
import { AlertTriangle, Calendar, Download } from 'lucide-react'
import { Link } from 'react-router-dom'

export interface CtaSectionProps {
  intensity: 'low' | 'medium' | 'high'
  title: string
  subtitle?: string
  whatsappNumber?: string         // default Hermógenes/Nai
  whatsappMessage?: string
  refazerHref?: string            // default volta para o form do mesmo assessment
  onDownloadPdf?: () => void      // default window.print()
}

const DEFAULT_WPP_NUMBER = '5519982132829'
const DEFAULT_WPP_MSG = 'Vim do Assessment'

export default function CtaSection({
  intensity,
  title,
  subtitle,
  whatsappNumber = DEFAULT_WPP_NUMBER,
  whatsappMessage = DEFAULT_WPP_MSG,
  refazerHref,
  onDownloadPdf = () => window.print(),
}: CtaSectionProps) {
  const wppUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`
  const boxClass = intensity === 'high'
    ? 'border-red-500 bg-gradient-to-br from-red-950/40 to-orange-950/30'
    : intensity === 'medium'
      ? 'border-cyan-500 bg-gradient-to-br from-cyan-950/40 to-emerald-950/30'
      : 'border-emerald-500/60 bg-emerald-950/20'
  const btnClass = intensity === 'high'
    ? 'bg-red-500 hover:bg-red-400 text-white'
    : 'bg-cyan-500 hover:bg-cyan-400 text-white'
  return (
    <section className={`rounded-2xl border-2 p-6 sm:p-8 text-center print:hidden ${boxClass}`}>
      {intensity === 'high' && <AlertTriangle className="h-10 w-10 text-red-400 mx-auto mb-3" />}
      <h2 className="text-2xl font-bold text-white">{title}</h2>
      {subtitle && <p className="text-sm text-slate-300 mt-2">{subtitle}</p>}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <a href={wppUrl} target="_blank" rel="noopener noreferrer"
          className={`inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold text-sm shadow-lg transition ${btnClass}`}>
          <Calendar className="h-4 w-4" /> {title}
        </a>
        <button type="button" onClick={onDownloadPdf}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-slate-700 text-slate-200 hover:bg-slate-800 text-sm font-semibold">
          <Download className="h-4 w-4" /> Baixar relatório (PDF)
        </button>
      </div>
      {refazerHref && (
        <p className="text-[10px] text-slate-500 mt-4">
          Ou refaça o diagnóstico com novos parâmetros · {' '}
          <Link to={refazerHref} className="text-cyan-300 underline">refazer</Link>
        </p>
      )}
    </section>
  )
}
